<script>
  import { trackLinkClick } from '../../../../../../../js/trackLinkClick';

  // Props
  export let id;
  export let url;
  export let linkText;
  export let ariaLabel;
</script>

<a
  {id}
  class="Link"
  href={url}
  aria-label={ariaLabel}
  use:trackLinkClick={{
    id,
    title: linkText,
    url,
  }}
>
  <span>{linkText}</span>
</a>

<style>@charset "UTF-8";
.Link {
  display: block;
  border-radius: 4px;
  color: var(--color-text, #1a1a1a);
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 14px;
  font-weight: var(--font-weight-medium, 500);
  line-height: 24px;
  text-decoration: none;
}
.Link:focus-visible:not(:active) {
  outline-offset: 2px;
  outline: 2px auto Highlight;
  outline: 2px auto -webkit-focus-ring-color;
}
.Link span {
  background-image: linear-gradient(var(--color-text), var(--color-text));
  background-size: 0% 1.5px;
  background-repeat: no-repeat;
  background-position: calc(100% - 0px) calc(100% - 1.5px);
  transition: background-size 250ms cubic-bezier(0.4, 0, 0.2, 1);
}
@media (hover: hover) {
  .Link:hover span {
    background-position: calc(0% + 0px) calc(100% - 1.5px);
    background-size: calc(100% - 0px) 1.5px;
  }
}
.Link span {
  padding-bottom: 3px;
}</style>
